import { getValidAccessToken } from "../Services/oauthServices";


export const SET_PARTNER_SMS_CONFIG = 'SET_PARTNER_SMS_CONFIG';

// export const individualMedicalPlans = (data) => ({
//   type: SET_PARTNER_SMS_CONFIG,
//   payload: data,
// });

const initialState = {
  partnerSmsConfig: null,
};

const partnerSmsConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PARTNER_SMS_CONFIG":
      return {
        ...state,
        partnerSmsConfig: action.payload,
      };
    default:
      return state;
  }
};

export default partnerSmsConfigReducer;

export const fetchPartnerSmsConfig = async (partnerId, dispatch) => {
  try {
    if (!partnerId) {
      console.warn('Skipping SMS config fetch: partnerId is missing.');
      return;
    }

    const token = await getValidAccessToken();
    const baseUrl = process.env.REACT_APP_API_URL;

    const response = await fetch(
      `${baseUrl}/api/v1/medical/partner/smsConfig?PARTNER_ID=${partnerId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();

    if (data?.data?.length) {
      dispatch({
        type: "SET_PARTNER_SMS_CONFIG",
        payload: data.data[0],
      });
    } else {
      console.warn('No SMS config found for partner.');
    }
  } catch (error) {
    console.error('Error fetching partner SMS config:', error);
  }
};